import config from "@/config"
import http from "@/utils/request"
export default {
    MiniProgramPay: {
		url: `${config.API_URL}/PCServiceWechatPay/MiniProgramPay`,
		name: "小程序支付",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
    QrCodePay: {
		url: `${config.API_URL}/PCServiceWechatPay/QrCodePay`,
		name: "小程序支付",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
    Refund: {
		url: `${config.API_URL}/PCServiceWechatPay/Refund`,
		name: "小程序支付",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
    Query: {
		url: `${config.API_URL}/PCServiceWechatPay/QueryByTransactionId`,
		name: "退款申请",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
    Close: {
		url: `${config.API_URL}/PCServiceWechatPay/OutTradeNoClose`,
		name: "退款申请",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	CodePay: {
		url: `${config.API_URL}/PCServiceWechatPay/CodePay`,
		name: "退款申请",
		post: async function(data){
			return await http.post(this.url, data, {
				headers: {
					//'response-status': 401
				}
			});
		}
	},
	GetoutTradeNo:{
	    url: `${config.API_URL}/PayService/GetoutTradeNo`,
	    name: "交易查询",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	},
	GetOutRequestNo:{
	    url: `${config.API_URL}/PayService/GetOutRequestNo`,
	    name: "交易查询",
	    post: async function (data) {
	        return await http.post(this.url, data, {
	            headers: {
	                //'response-status': 401
	            }
	        });
	    }
	}
}
